export default "__VITE_ASSET__BQOBRJU9__"